// src/services/portariaService.js
import api from "./api";
const qs = p => new URLSearchParams(Object.entries(p).filter(([,v])=>v!==""&&v!==undefined)).toString();

const portariaService = {
  // Dashboard
  dashboard:        (p={})    => api("GET",  `/portaria/dashboard?${qs(p)}`),
  // Moradores
  moradores:        (p={})    => api("GET",  `/portaria/moradores?${qs(p)}`),
  criarMorador:     (data)    => api("POST", "/portaria/moradores", data),
  atualizarMorador: (id,data) => api("PUT",  `/portaria/moradores/${id}`, data),
  removerMorador:   (id)      => api("DELETE",`/portaria/moradores/${id}`),
  // Registros entrada/saída
  registros:        (p={})    => api("GET",  `/portaria/registros?${qs(p)}`),
  registrarEntrada: (data)    => api("POST", "/portaria/registros", data),
  registrarSaida:   (id)      => api("PATCH",`/portaria/registros/${id}/saida`),
  excluirRegistro:  (id,data) => api("DELETE",`/portaria/registros/${id}`, data),
  // Pré-autorizações
  preautorizacoes:    (p={})    => api("GET",  `/portaria/preautorizacoes?${qs(p)}`),
  criarAutorizacao:   (data)    => api("POST", "/portaria/preautorizacoes", data),
  cancelarAutorizacao:(id)      => api("DELETE",`/portaria/preautorizacoes/${id}`),
  validarQR:          (token)   => api("GET",  `/portaria/validar-qr/${token}`),
  // Veículos (somente leitura — cadastro é responsabilidade do condômino)
  veiculos:           (p={})    => api("GET",  `/portaria/veiculos?${qs(p)}`),
  veiculosRegistros:  (p={})    => api("GET",  `/portaria/veiculos/registros?${qs(p)}`),
  registrarVeiculo:   (data)    => api("POST", "/portaria/veiculos/entrada", data),
  saidaVeiculo:       (id)      => api("PATCH",`/portaria/veiculos/registros/${id}/saida`),
  // Ocorrências
  ocorrenciasPortaria:(p={})    => api("GET",  `/portaria/ocorrencias?${qs(p)}`),
  editarOcorrencia:    (id,data) => api("PATCH", `/portaria/ocorrencias/${id}`, data),
  excluirOcorrencia:   (id)      => api("DELETE",`/portaria/ocorrencias/${id}`),
  criarOcorrenciaPort:(data)    => api("POST", "/portaria/ocorrencias", data),
  atualizarStatusOc:  (id,data) => api("PATCH",`/portaria/ocorrencias/${id}/status`, data),
  // Relatório
  relatorio:          (p={})    => api("GET",  `/portaria/relatorio?${qs(p)}`),
  // Encomendas
  encomendas:        (p={})    => api("GET",   `/portaria/encomendas?${qs(p)}`),
  registrarEncomenda:(data)    => api("POST",  "/portaria/encomendas", data),
  registrarRetirada: (id,data) => api("PATCH", `/portaria/encomendas/${id}/retirada`, data),
  editarEncomenda:   (id,data) => api("PATCH", `/portaria/encomendas/${id}`, data),
  excluirEncomenda:  (id)      => api("DELETE",`/portaria/encomendas/${id}`),
  editarRegistro:    (id,data) => api("PATCH", `/portaria/registros/${id}`, data),
  // Avisos do condômino
  avisos:            (p={})    => api("GET",  `/portaria/avisos?${qs(p)}`),
  atualizarAviso:    (id,data) => api("PATCH",`/portaria/avisos/${id}`, data),
  // Prestadores
  prestadores:       (p={})    => api("GET",  `/portaria/prestadores?${qs(p)}`),
  buscarPrestadores: (p={})    => api("GET",  `/portaria/prestadores/busca?${qs(p)}`),
  criarPrestador:    (data)    => api("POST", "/portaria/prestadores", data),
  atualizarPrestador:(id,data) => api("PUT",  `/portaria/prestadores/${id}`, data),
  autorizacoesPrestador:(p={}) => api("GET",  `/portaria/prestadores/autorizacoes?${qs(p)}`),
};
export default portariaService;
